import { useEffect, useState } from 'react';
import api from '../utils/axios';

export default function ClientLogo({ clientId, showClientName = true }: { clientId: number, showClientName: boolean }) {
  const [url, setUrl] = useState<string | null>(null);
  const [clientName, setClientName] = useState<string | null>(null);

  useEffect(() => {
    api.get(`/client/${clientId}`)
      .then(res => {
        if(res.data.logo_url) {
          const logo_url = "/api/clients/"+ clientId +"/logo";
          setUrl(logo_url || null);
          // console.log('Client data:', res.data); 
        }
        setClientName(res.data.name || null);
      })
      .catch((error) => {
        console.error('Failed to fetch client data:', error);
      });
  }, [clientId]);

  return (
    <>
      {showClientName && !url ? <span style={{ marginRight: '2rem' }}>{clientName}</span> : null}
      {url ? <img src={url} alt="Logo" style={{ height: 28, objectFit: 'contain', marginRight: '2rem' }} /> : null}
    </>
  );
}
